var map = {
	"./additionalInfoIcon.svg": 601,
	"./arrowBottomIconSharpSmall.svg": 602,
	"./arrowLeftIcon.svg": 603,
	"./arrowMediumTop.svg": 604,
	"./arrowRightIcon.svg": 605,
	"./arrowRightIconSharp.svg": 606,
	"./arrowRightSmallIcon.svg": 607,
	"./arrowScalableIcon.svg": 608,
	"./arrowSelect2.svg": 609,
	"./arrowSelectIcon.svg": 610,
	"./benefit1.svg": 611,
	"./benefit2.svg": 612,
	"./benefit3.svg": 613,
	"./cardsIcon.svg": 614,
	"./circleInfoIcon.svg": 615,
	"./copyIcon copy.svg": 616,
	"./copyIcon.svg": 617,
	"./crossIcon.svg": 618,
	"./crossIcon2.svg": 619,
	"./crossIcon3.svg": 620,
	"./crossIconSmall.svg": 621,
	"./crossSmallIcon.svg": 622,
	"./defaultCategoryIcon.svg": 623,
	"./depNumberIcon.svg": 624,
	"./elfCentralIcon.svg": 625,
	"./equalitySign.svg": 626,
	"./errorIcon.svg": 528,
	"./eyeClosedIcon.svg": 627,
	"./eyeOpenIcon.svg": 628,
	"./favoritesIcon.svg": 629,
	"./favoritesLabelIcon.svg": 630,
	"./filterDivider.svg": 631,
	"./filterIcon.svg": 632,
	"./frequencyIcon.svg": 633,
	"./fsAmountIcon.svg": 634,
	"./fullScreenIcon.svg": 635,
	"./gameIcon.svg": 636,
	"./gemIcon.svg": 637,
	"./goldGiftIcon.svg": 638,
	"./hamburgerIcon.svg": 639,
	"./infoIcon.svg": 640,
	"./infoIconSmall.svg": 641,
	"./infoSymbol.svg": 642,
	"./levelBackground.svg": 643,
	"./levelBackgroundNew.svg": 644,
	"./linkIcon.svg": 645,
	"./lockIcon.svg": 646,
	"./lockSharpIcon.svg": 647,
	"./maxBonusAmountIcon.svg": 648,
	"./maxWinFsIcon.svg": 649,
	"./menuIcon.svg": 650,
	"./minDepIcon.svg": 651,
	"./minusIcon.svg": 652,
	"./noTournamentIcon.svg": 653,
	"./playIcon.svg": 654,
	"./plusIcon.svg": 655,
	"./polygon.svg": 656,
	"./preloaderDotsAnimation.svg": 657,
	"./preloaderSpinnerAnimation.svg": 658,
	"./present2Icon.svg": 659,
	"./presentIcon.svg": 660,
	"./promoIcon.svg": 661,
	"./recentIcon.svg": 662,
	"./search2Icon.svg": 663,
	"./search3Icon.svg": 664,
	"./sharpTickIcon copy.svg": 665,
	"./sharpTickIcon.svg": 666,
	"./smallInfoSymbol.svg": 667,
	"./smoothArrowIcon.svg": 668,
	"./successIcon.svg": 669,
	"./supportIcon.svg": 670,
	"./tag1Icon.svg": 671,
	"./tag2Icon.svg": 672,
	"./tag3Icon.svg": 673,
	"./tag4Icon.svg": 674,
	"./tickIcon.svg": 675,
	"./unverified.svg": 676,
	"./verified.svg": 677,
	"./wagerIcon.svg": 678,
	"./wagerTimeIcon.svg": 679,
	"./warningIcon.svg": 680,
	"./zoomIcon.svg": 681
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 600;